(() => {
  const initialize = (subnavigation) => {
    if (subnavigation.dataset.collectionSubnavigationInitialized === 'true') return;

    const viewport = subnavigation.querySelector('[data-collection-subnavigation-viewport]');
    const previousButton = subnavigation.querySelector('[data-collection-subnavigation-previous]');
    const nextButton = subnavigation.querySelector('[data-collection-subnavigation-next]');

    if (!viewport || !previousButton || !nextButton) return;

    subnavigation.dataset.collectionSubnavigationInitialized = 'true';

    const updateNextButton = () => {
      const remainingScroll = viewport.scrollWidth - viewport.clientWidth - viewport.scrollLeft;
      const isScrollable = viewport.scrollWidth - viewport.clientWidth > 2;
      previousButton.hidden = !isScrollable || viewport.scrollLeft <= 2;
      nextButton.hidden = !isScrollable || remainingScroll <= 2;
    };

    const scroll = (direction) => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      viewport.scrollBy({
        left: direction * Math.max(viewport.clientWidth * 0.7, 180),
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    };

    previousButton.addEventListener('click', () => scroll(-1));
    nextButton.addEventListener('click', () => scroll(1));

    viewport.addEventListener('scroll', updateNextButton, { passive: true });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(updateNextButton);
      resizeObserver.observe(viewport);
    } else {
      window.addEventListener('resize', updateNextButton);
    }

    requestAnimationFrame(updateNextButton);
  };

  document.querySelectorAll('[data-collection-subnavigation]').forEach(initialize);
})();
